import { render, staticRenderFns } from "./CreateApikey.vue?vue&type=template&id=33177cbe&scoped=true"
import script from "./CreateApikey.vue?vue&type=script&lang=js"
export * from "./CreateApikey.vue?vue&type=script&lang=js"
import style0 from "./CreateApikey.vue?vue&type=style&index=0&id=33177cbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33177cbe",
  null
  
)

export default component.exports